import h from 'hyperscript';

// add article breaker if table is too large
document.querySelectorAll('.table').forEach(($table) => {
  if (!$table.parentNode.classList.contains('article__breaker-inner')) {
    const width = $table.querySelector('.table__scroll-wrapper').firstElementChild.clientWidth;

    // max content width inside articles 650px
    if (width > 650) {
      const $articleBreaker = h(
        'div.article__breaker',
        h('div.article__breaker-inner'),
      );
      $table.parentNode.appendChild($articleBreaker);
      $articleBreaker.querySelector('.article__breaker-inner').appendChild($table);

      if (width > 1010) {
        $articleBreaker.classList.add('article__breaker--fullwidth', 'article__breaker--themed', 't-beige');

        $table.querySelectorAll('tbody td, thead th').forEach(($td) => {
          const characterCount = $td.innerHTML.length;
          if (characterCount > 30) {
            $td.classList.add('table__cell--long');
          }
        });
      }
    }
  }
});
